<template>
    <div id="News_And_Update" class="dashboard-card d-flex">
        <CardTemplate>
            <!-- HEADER -->
            <template #header>
                <section class="card-title">
                    <span> News and Updates</span>
                </section>
            </template>
            <!-- CONTENT -->
            <!-- LOADING -->
            <template #content>
                <div class="mt-3 text-center" v-if="isLoading && !hasError">
                    <i class="fas fa-spinner fa-pulse fa-fw"></i>
                    <b>Loading News And Updates</b>
                    <i class="fas fa-spinner fa-pulse fa-fw"></i>
                </div>
                <!-- ERROR -->
                <div class="mt-5 text-center" v-if="hasError && !isLoading">
                    <p>
                        There was a problem while fetching your news and updates.
                        <br />
                        Please try again.
                    </p>
                    <button class="btn btn-primary" @click="getNewsAndUpdate()">Try Again</button>
                </div>
                <!-- NO DATA -->
                <section v-if="newsAndUpdates.length === 0 && !isLoading && !hasError" class="no-data">
                    <i class="mb-3"> Good Job! There were no issues identified with your visits. </i>
                </section>
                <!-- DATA -->
                <div class="h-100 overflow-auto position-relative">
                    <div class="news-item" v-for="newsAndUpdate in newsAndUpdates" :key="newsAndUpdate">
                        <a :href="newsAndUpdate.Http" target="_blank" class="mt-2 mb-1 fw-bold">
                            {{ newsAndUpdate.Name }}
                        </a>
                        <p class="mb-1">
                            {{ newsAndUpdate.Desc }}
                        </p>
                    </div>
                    <strong class="mt-auto mb-4 last-div position-absolute">
                        <a href="https://www.axxess.com/blog/" target="_blank"> View All News and Updates </a>
                    </strong>
                </div>
            </template>
        </CardTemplate>
    </div>
</template>

<script lang="ts" src="./NewsAndUpdates.ts"></script>
